import * as actionTypes from "../actions/actionTypes";
import { api } from "../../common/api-utils";

// Meta config  actions
const getMetaConfigRequest = () => ({
  type: actionTypes.GET_METACONFIG_REQUEST,
});

const getMetaConfigSuccess = (payload) => ({
  type: actionTypes.GET_METACONFIG_SUCCESS,
  payload,
});

const getMetaConfigFailure = (error) => ({
  type: actionTypes.GET_METACONFIG_FAILURE,
  error,
});


export const getMetaConfig = () => async (dispatch) => {
  try {
    dispatch(getMetaConfigRequest());
    const res = await api.get(`/V8/meta/config`);
    if (res.ok) {
      dispatch(getMetaConfigSuccess(res.data));
      return;
    }
    dispatch(getMetaConfigFailure(res.data.errors.detail));
  } catch (ex) {
    dispatch(getMetaConfigFailure(ex));
  }
};

export const toggleTheme = (theme) => ({
  type: actionTypes.TOGGLE_THEME,
  payload: theme
});

// Current User actions
const getCurrentUserRequest = () => ({
  type: actionTypes.GET_CURRENTUSER_REQUEST,
});

const getCurrentUserSuccess = (payload) => ({
  type: actionTypes.GET_CURRENTUSER_SUCCESS,
  payload,
});

const getCurrentUserFailure = (error) => ({
  type: actionTypes.GET_CURRENTUSER_FAILURE,
  error,
});
export const getCurrentUser = () => async dispatch => {
  try {
    dispatch(getCurrentUserRequest());
    const res = await api.get(`/V8/current-user`);

    if (res.ok) {
      dispatch(getCurrentUserSuccess(res.data));
      return;
    }
    dispatch(getCurrentUserFailure(res.data.errors.detail));
  } catch (ex) {
    dispatch(getCurrentUserFailure(ex));
  }
}


//User preference data actions
const getUserPreferenceRequest = () => ({
  type: actionTypes.USER_PREFERENCE_REQUEST,
});

const getUserPreferenceSuccess = (payload) => ({
  type: actionTypes.USER_PREFERENCE_SUCCESS,
  payload,
});

const getUserPreferenceFailure = (error) => ({
  type: actionTypes.USER_PREFERENCE_FAILURE,
  error,
});
export const getUserPreference = (currentUser) => async (dispatch) => {
  try {
    dispatch(getUserPreferenceRequest());
    const res = await api.get("/V8/user-preferences/" + currentUser);
    if (res.ok) {
      dispatch(getUserPreferenceSuccess(res.data.data));
      return;
    }
    dispatch(getUserPreferenceFailure(res.data.message));
  } catch (e) {
    dispatch(getUserPreferenceFailure(e));
  }
};

export const updateBaseUrl = (baseUrl) => ({
  type: actionTypes.UPDATE_BASE_URL,
  baseUrl
})
